import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const presidentActivity = createAsyncThunk(
  "presidentActivity",
  async () => {
    try {
      const cookies = new Cookies();
      const id = cookies.get("societyId");
      const token = cookies.get("token");
      const response = await AxiosInstance.get(
        `${API_KEY}/api/activity/list/${id}`,

        {
          headers: {
            Authorization: `Barear ${token}`,
          },
          "Content-Type": "application/json",
        }
      );

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  presidentActivityData: null,
  isError: false,
  errorMessage: "",
};
const presidentActivitySlice = createSlice({
  name: "presidentActivity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(presidentActivity.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(presidentActivity.fulfilled, (state, action) => {
      state.isLoading = false;
      state.presidentActivityData = action.payload;
    });
    builder.addCase(presidentActivity.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default presidentActivitySlice.reducer;
